import React from "react";

import { FormLabel, InputAdornment, TextField } from "@mui/material";
import { useController } from "react-hook-form";

import { Theme } from "../../../Style/Theme";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";
import { Text } from "../Typography/Text/Text";
import Label from "./Label";

export const TextInput = ({
  control,
  label,
  name,
  width,
  disabled,
  showLabel,
  fullWidth,
  endAdornment,
  placeholder,
  startAdornment,
  color,
  icon,
  required,
  transformText,
  maxLength,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  return (
    <FormItemsWrap padding={"0px 0px 12px 0px"}>
      <Label label={label} required={required} />
      <TextField
        onKeyDown={transformText}
        fullWidth={fullWidth}
        disabled={disabled}
        variant="outlined"
        sx={{
          "& .MuiOutlinedInput-root.Mui-disabled": {
            borderRadius: "8px",
          },
          "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
            {
              borderRadius: "8px",
            },
          "& .MuiInputBase-input.Mui-disabled": {
            borderRadius: "8px",
            borderColor: "transparent",
          },
          "& .MuiOutlinedInput-root.Mui-disabled:hover .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "rgba(0, 0, 0, 0.23)",
            },
        }}
        inputProps={{
          maxLength: maxLength,
          style: {
            width: width,
            backgroundColor: disabled && "#E5E5EA",
            color: disabled && "#8E8E93",
            WebkitBoxShadow: "none",
          },
        }}
        error={fieldState?.invalid}
        helperText={fieldState?.error?.message}
        value={field.value}
        label={showLabel ? label : undefined}
        placeholder={placeholder ? placeholder : ""}
        {...field}
        InputProps={{
          endAdornment: endAdornment && (
            <InputAdornment position="end">{icon}</InputAdornment>
          ),
          startAdornment: startAdornment && (
            <InputAdornment position="end">{icon}</InputAdornment>
          ),
          style: {
            background: color ? color : "",
          },
        }}
      />
    </FormItemsWrap>
  );
};

export const TextInput2 = ({
  control,
  label,
  name,
  width,
  size,
  readOnly,
  disabled,
  showLabel,
  color,
  fullWidth,
  icon,
  multiline,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  return (
    <TextField
      fullWidth={fullWidth}
      disabled={disabled}
      variant="standard"
      size={size ?? "small"}
      inputProps={{
        style: {
          width: width,
          fontSize: "13px",
          fontStyle: "normal",
          lineHeight: "18px",
          letterSpacing: "-0.78px",
          color: color ? color : Theme.palette.text.grayDark,
        },
      }}
      multiline={multiline}
      error={fieldState?.invalid}
      helperText={fieldState?.error?.message}
      placeholder={label}
      value={field.value}
      label={showLabel ? label : undefined}
      {...field}
      InputProps={{
        endAdornment: <InputAdornment position="end">{icon}</InputAdornment>,
      }}
    />
  );
};

export const TextInput3 = ({
  control,
  label,
  name,
  width,
  size,
  disabled,
  showLabel,
  fullWidth,
  height,
  icon,
  color,
  placeholder,
  borderRadius,
  required,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  return (
    <FormItemsWrap>
      <FormLabel
        required={required}
        sx={{ "& .MuiFormLabel-asterisk": { color: "#FF0000" } }}
        component="legend"
      >
        {label}
      </FormLabel>
      <TextField
        fullWidth={fullWidth}
        disabled={disabled}
        variant="outlined"
        size={size ?? "small"}
        inputProps={{
          style: {
            width: width,
            height: height ? height : "auto",
          },
        }}
        placeholder={placeholder ? placeholder : ""}
        error={fieldState?.invalid}
        helperText={fieldState?.error?.message}
        value={field.value}
        label={showLabel ? label : undefined}
        {...field}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">{icon}</InputAdornment>
          ),
          style: {
            background: color ? color : Theme.palette.text.grayDark,
            borderRadius: borderRadius ? borderRadius : "",
          },
        }}
      />
    </FormItemsWrap>
  );
};

export const TextInput4 = ({
  control,
  label,
  name,
  width,
  size,
  disabled,
  showLabel,
  fullWidth,
  endAdornment,
  placeholder,
  startAdornment,
  color,
  icon,
  required,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  return (
    <FormItemsWrap>
      <FormLabel
        required={required}
        sx={{ "& .MuiFormLabel-asterisk": { color: "#FF0000" } }}
        component="legend"
      >
        {label}
      </FormLabel>
      <TextField
        fullWidth={fullWidth}
        disabled={disabled}
        variant="outlined"
        size={size ?? "small"}
        inputProps={{
          style: {
            width: width,
          },
        }}
        error={fieldState?.invalid}
        helperText={fieldState?.error?.message}
        value={field.value}
        label={showLabel ? label : undefined}
        placeholder={placeholder ? placeholder : ""}
        {...field}
        InputProps={{
          endAdornment: endAdornment && (
            <InputAdornment position="end">{icon}</InputAdornment>
          ),
          startAdornment: startAdornment && (
            <InputAdornment position="end">{icon}</InputAdornment>
          ),
          style: {
            background: color ? color : "",
            border: "1px solid var(--system-gray-04-light, #D1D1D6)",
            borderRadius: "7px",
          },
        }}
      />
    </FormItemsWrap>
  );
};

//password
export const TextInput5 = ({
  control,
  label,
  name,
  width,
  size,
  disabled,
  showLabel,
  fullWidth,
  endAdornment,
  placeholder,
  startAdornment,
  color,
  fontcolor,
  icon,
  password,
  required,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  return (
    <FormItemsWrap width={width}>
      <FormLabel required={required} component="legend">
        <Text text={label} color={fontcolor} />
      </FormLabel>
      <TextField
        type={password ? "password" : "text"}
        fullWidth={fullWidth}
        disabled={disabled}
        variant="outlined"
        size={size ?? "small"}
        inputProps={{
          style: {
            width: width,
          },
        }}
        error={fieldState?.invalid}
        helperText={fieldState?.error?.message}
        value={field.value}
        label={showLabel ? label : undefined}
        placeholder={placeholder ? placeholder : ""}
        {...field}
        InputProps={{
          endAdornment: endAdornment && (
            <InputAdornment position="end">{icon}</InputAdornment>
          ),
          startAdornment: startAdornment && (
            <InputAdornment position="end">{icon}</InputAdornment>
          ),
          style: {
            background: color ? color : "",
            border: "1px solid var(--system-gray-04-light, #D1D1D6)",
            borderRadius: "7px",
          },
        }}
      />
    </FormItemsWrap>
  );
};

//password
export const TextInput6 = ({
  control,
  label,
  name,
  width,
  size,
  disabled,
  showLabel,
  fullWidth,
  endAdornment,
  placeholder,
  startAdornment,
  color,
  fontcolor,
  icon,
  password,
  required,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  return (
    <FormItemsWrap width={width}>
      <FormLabel required={required} component="legend" sx={{ width: "100%" }}>
        <Text text={label} color={fontcolor} />
      </FormLabel>
      <TextField
        type={"number"}
        fullWidth={fullWidth}
        disabled={disabled}
        variant="outlined"
        size={size ?? "small"}
        inputProps={{
          style: {
            width: width,
          },
        }}
        error={fieldState?.invalid}
        helperText={fieldState?.error?.message}
        value={field.value}
        label={showLabel ? label : undefined}
        placeholder={placeholder ? placeholder : ""}
        {...field}
        InputProps={{
          endAdornment: endAdornment && (
            <InputAdornment position="end">{icon}</InputAdornment>
          ),
          startAdornment: startAdornment && (
            <InputAdornment position="end">{icon}</InputAdornment>
          ),
          style: {
            background: color ? color : "",
            border: "1px solid var(--system-gray-04-light, #D1D1D6)",
            borderRadius: "7px",
          },
        }}
      />
    </FormItemsWrap>
  );
};
// search box
export const TextInput7 = ({
  label,
  width,
  size,
  disabled,
  showLabel,
  fullWidth,
  endAdornment,
  placeholder,
  startAdornment,
  color,
  icon,
  required,
  getSearchText,
  searchValue,
}) => {
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      // Call the provided event handler when Enter is pressed
      getSearchText && getSearchText(event.target.value);
    }
  };

  let timer;
  const waitTime = 1000;
  const handleKeyUp = (event) => {
    let prevousSearchText = new String(searchValue).trim();
    let searchText = new String(event.target.value).trim();
    let searchTextLength = searchText.length;

    if (
      (event.key === "Backspace" || searchTextLength > 2) &&
      prevousSearchText !== searchText
    ) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getSearchText(event.target.value);
      }, waitTime);
    }
  };
  return (
    <FormItemsWrap>
      <FormLabel
        required={required}
        sx={{ "& .MuiFormLabel-asterisk": { color: "#FF0000" }, width: "100%" }}
        component="legend"
      >
        {label}
      </FormLabel>
      <TextField
        onKeyUp={handleKeyUp}
        fullWidth={fullWidth}
        disabled={disabled}
        variant="outlined"
        size={size ?? "small"}
        inputProps={{
          style: {
            width: width,
          },
        }}
        label={showLabel ? label : undefined}
        placeholder={placeholder ? placeholder : ""}
        InputProps={{
          endAdornment: endAdornment && (
            <InputAdornment position="end">{icon}</InputAdornment>
          ),
          startAdornment: startAdornment && (
            <InputAdornment
              style={{
                marginRight: "8px",
                width: "16px",
              }}
              position="end"
            >
              {icon}
            </InputAdornment>
          ),
          style: {
            background: color ? color : "",
            borderRadius: "7px",
            padding: "3px",
            fontSize: "13px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "18px",
            letterSpacing: "-0.078px",
            textJustify: "center",
          },
        }}
      />
    </FormItemsWrap>
  );
};
